/**
 * 匠人图集分类 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const tradesmanthumb = {
    // 列表
    list(params) {
        return axios.get(api + 'tradesman/thumblist', { params: params })
    },
    create(params) {
        return axios.post(api + 'tradesman/thumbcreate', qs.stringify(params))
    },
    detail(params) {
        return axios.get(api + 'tradesman/thumbdetail', { params: params })
    },
    remove(params) {
        return axios.post(api + 'tradesman/thumbremove', qs.stringify(params))
    },
    edit(params) {
        return axios.post(api + 'tradesman/thumbedit', qs.stringify(params))
    },
}

// 导出接口
export default tradesmanthumb
